import React from 'react';
import { useTranslation } from "react-i18next";
import { ReactComponent as ChevronLeft } from "Assets/icons/chevronLeft.svg";
import { ReactComponent as ChevronRight } from "Assets/icons/chevronRight.svg";
const ListingIntroduction = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;

    return (
        <div className="megaMenuContent">
            <div className="row h-100 align-items-center">
                <div className="col-12">
                    <div className="row">
                        <div className="col-4 d-flex justify-content-center align-items-center mb-3">
                            <a href="/Listing/ListingIntroduction/#listing-physical-market" className="tradesFeeItems py-2 px-2 w-100">                              
                                {t('physicalMarketAcceptance')}
                            </a>
                        </div>
                        <div className="col-4 d-flex justify-content-center align-items-center mb-3">
                            <a href="/Listing/ListingIntroduction/#fund-acceptance" className="tradesFeeItems py-2 px-2 w-100">                                
                                {t('fundAcceptance')}
                            </a>
                        </div>
                        <div className="col-4 d-flex justify-content-center align-items-center mb-3">
                            <a href="/Listing/ListingIntroduction/#listing-warehouse" className="tradesFeeItems py-2 px-2 w-100">
                                {t('warehouseReceiptAcceptance')}
                            </a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-4 d-flex justify-content-center align-items-center mb-3">
                            <a href="/Listing/ListingIntroduction/#secondary-market" className="tradesFeeItems py-2 px-2 w-100">                               
                                {t('secondaryMarketGoodsAcceptance')}
                            </a>
                        </div>
                        <div className="col-4 d-flex justify-content-center align-items-center mb-3">
                            <a href="/Listing/ListingIntroduction/#capacity-certificate" className="tradesFeeItems py-2 px-2 w-100">
                                {t('capacityCertificateAcceptance')}
                            </a>
                        </div>
                        <div className="col-4 d-flex justify-content-center align-items-center mb-3">
                            <a href="/Listing/ListingIntroduction/#fees" className="tradesFeeItems py-2 px-2 w-100">
                                {t('fees')}
                            </a>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-4 d-flex justify-content-center align-items-center mb-3">
                            <a href="/Listing/ListingIntroduction/#derivative" className="tradesFeeItems py-2 px-2 w-100">
                                {t('derivativeCommoditySecuritiesAcceptance')}
                            </a>
                        </div>
                        <div className="col-4 d-flex justify-content-center align-items-center mb-3">
                            <a href="/Listing/ListingIntroduction/#energy-saving" className="tradesFeeItems py-2 px-2 w-100">
                                {t('energySavingCertificateAcceptance')}
                            </a>
                        </div>
                    </div>
                </div>
                <div className="col-12 text-start mt-2">
                    <a href="/Listing/ListingIntroduction" target="_blank" className="btn rounded-5 bg-primary text-white d-inline-flex justify-content-center align-items-center gap-1" >
                        {t("viewAll")}
                        <span className="btn p-0 btn-read-more rounded-circle bg-white text-blue d-flex justify-content-center align-items-center">
                            {currentLang === "en" ? <ChevronRight width={15} height={10} /> : <ChevronLeft width={15} height={10} />}   
                        </span>
                    </a>
                </div>

            </div>

        </div>
    );
};

export default ListingIntroduction;
